import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";
import { fadeUp, stagger, viewport } from "../lib/motion";
import Breadcrumb from "../components/site/Breadcrumb";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.blog().then(setPosts);
  }, []);

  return (
    <div>
      <section className="bg-[#F8FAF8] border-b border-[#E2E8E4] pt-12 pb-14">
        <div className="max-w-7xl mx-auto px-5 md:px-10">
          <Breadcrumb items={[{ label: "Blog" }]} />
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#1D6B2A] mt-6 mb-3">
            Insights & guides
          </p>
          <h1 className="font-head text-4xl md:text-6xl font-medium tracking-tighter text-[#0A1C0E]">
            The Packaging Journal
          </h1>
          <p className="text-lg text-[#3A4D3E] mt-3 max-w-xl">
            Practical tips on packaging, sustainability and growing your food brand.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-5 md:px-10">
          {posts.length === 0 ? (
            <p className="text-center text-[#3A4D3E] py-20">No posts yet. Check back soon.</p>
          ) : (
            <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {posts.map((p, i) => (
                <motion.article key={p.slug} variants={fadeUp} custom={i} className="group">
                  <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="block">
                    <div className="rounded-2xl overflow-hidden aspect-[16/10] border border-[#E2E8E4] mb-5">
                      <img src={p.cover_image} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    </div>
                    <span className="text-xs font-bold tracking-[0.15em] uppercase text-[#1D6B2A]">{p.category}</span>
                    <h2 className="font-head text-2xl font-semibold text-[#0A1C0E] mt-2 group-hover:text-[#1D6B2A] transition-colors flex items-start gap-1">
                      {p.title}
                      <ArrowUpRight size={20} className="shrink-0 mt-1 opacity-0 group-hover:opacity-100 transition-opacity" />
                    </h2>
                    <p className="text-[#3A4D3E] mt-2 line-clamp-2">{p.excerpt}</p>
                    <p className="text-sm text-[#3A4D3E]/70 mt-3">{p.author}</p>
                  </Link>
                </motion.article>
              ))}
            </motion.div>
          )}
        </div>
      </section>
    </div>
  );
}
